import dynamic from 'next/dynamic';

const DynamicBannerNotificationsManager = dynamic(() => import('@components/BannerNotifications'), {
    ssr: false,
});

export default DynamicBannerNotificationsManager;
